import React from "react";
import Dashboard from "../components/Dashboard";

const DashboardScreen = (props) => {
  return <Dashboard {...props} />;
};
export default DashboardScreen;
